import util, {
    getCookie,
    setCookie,
    getCookieName,
    parseStandardizedCookieValue,
    getCookieDuration,
    createStandardizedCookieValue
} from './utils/util';
import { randomId, getSessionData, setSessionData, refreshSessionData } from './utils/session';
import { urlCollect } from './api';
import { SHA1 } from './utils/SHA1';
import {
    LEGACY_QUERY_PARAMS,
    GLOBAL_QUERY_PARAMS,
    SESSION_PARAMS,
    COOKIE_PREFIX,
    WPCPX_COOKIE,
    MULTIPLE_INITS,
    WPADUID_COOKIE
} from './constans';

export default {
    setMatchedParamsAsCookie(query, matching, time) {
        Object.keys(matching).forEach(key => {
            const param = matching[key];
            if (query.hasOwnProperty(param)) {
                // process source_clid separately
                if (param !== 'wpclid') setCookie(getCookieName(param), query[param], time);
            }
        });
    },

    processSourceClid(incomingValue) {
        const paramName = GLOBAL_QUERY_PARAMS.source_clid;
        const current = parseStandardizedCookieValue(getCookie(getCookieName(paramName)));
        const incoming = parseStandardizedCookieValue(
            incomingValue && decodeURIComponent(incomingValue)
        );
        const setSourceClidCookie = value =>
            setCookie(getCookieName(paramName), value, getCookieDuration(paramName));

        // existing non-standardized cookie, no incoming
        if (!incoming && current && !current.date) {
            setSourceClidCookie(createStandardizedCookieValue(current.full));
            return;
        }

        // currently standardized, no incoming or incoming older
        if (
            !incoming ||
            (current &&
                current.date &&
                incoming.date &&
                current.date.valueOf() > incoming.date.valueOf())
        )
            return;

        setSourceClidCookie(createStandardizedCookieValue(incoming.value || incoming.full));
    },

    generateTransactionSignature(data) {
        const exclude = ['t'];

        const result = Object.keys(data).reduce((obj, key) => {
            if (exclude.indexOf(key) === -1) {
                obj[key] = data[key];
            }
            return obj;
        }, {});

        return `${COOKIE_PREFIX}wph.${SHA1(util.toQueryString(result))}`;
    },

    getDebugInfo(params) {
        if (params[this.name] === 'debug') {
            return true;
        }

        return false;
    },

    getCookies() {
        const prefix = COOKIE_PREFIX;

        return {
            allani: {
                id: util.getCookie(prefix + LEGACY_QUERY_PARAMS.atid),
                hash: util.getCookie(prefix + LEGACY_QUERY_PARAMS.ath)
            },
            domodi: {
                id: util.getCookie(prefix + LEGACY_QUERY_PARAMS.atid2),
                hash: util.getCookie(prefix + LEGACY_QUERY_PARAMS.ath2),
                shopId: util.getCookie(prefix + LEGACY_QUERY_PARAMS.ats),
                userId: util.getCookie(prefix + LEGACY_QUERY_PARAMS.atu),
                time: util.getCookie(prefix + LEGACY_QUERY_PARAMS.att)
            },
            global: Object.keys(GLOBAL_QUERY_PARAMS).reduce((obj, key) => {
                obj[key] = util.getCookie(getCookieName(GLOBAL_QUERY_PARAMS[key]));
                return obj;
            }, {}),
            session: Object.keys(SESSION_PARAMS).reduce((obj, key) => {
                obj[key] = getSessionData(SESSION_PARAMS[key]);
                return obj;
            }, {}),
            wpcpx: util.getCookie(WPCPX_COOKIE),
            wph_aduid: util.getCookie(WPADUID_COOKIE)
        };
    },

    getBaseData() {
        return {
            k: this.key,
            h: location.hostname,
            r: document.referrer,
            l: location.href,
            t: Date.now(),
            v: process.env.APP_VERSION
        };
    },

    getAllSessionData(sessionCookies) {
        const sessionData = {};

        for (let key in sessionCookies) {
            if (sessionCookies.hasOwnProperty(key)) {
                if (sessionCookies[key] && sessionCookies[key].full !== undefined)
                    sessionData[SESSION_PARAMS[key]] = sessionCookies[key].full;
            }
        }

        return sessionData;
    },

    getDebuggingData() {
        const debuggingData = {};

        // detect multiple init events
        if (window.wph_init === undefined) window.wph_init = [this.key];
        else if (Array.isArray(window.wph_init)) {
            debuggingData.multi = window.wph_init.includes(this.key)
                ? MULTIPLE_INITS.same_id
                : MULTIPLE_INITS.different_id;
            window.wph_init.push(this.key);
        }

        return debuggingData;
    },

    createPixel(data, url) {
        const sources = url ? [url] : urlCollect;
        const eventId = SHA1(util.toQueryString(data));
        data.i = eventId;

        return sources.map(source => {
            const image = new Image(1, 1);
            const hasParam = source.indexOf('?') > -1;

            image.src = `${source}${hasParam ? '&' : '?'}${util.toQueryString(data)}`;
            return image;
        });
    },

    contentMapper(obj = {}) {
        if (typeof obj.content_ids === 'undefined' && obj.contents) {
            obj.content_ids = obj.contents.map(item => (item.id ? item.id : 0));
        }

        return Object.keys(obj).reduce((content, key) => {
            const val = obj[key];

            if (val || val === 0) {
                switch (key) {
                    case 'content_ids':
                        content['c_item_ids'] = val;
                        content['c_content_ids'] = val;
                        break;
                    case 'contents':
                        content['c_contents'] = JSON.stringify(val);
                        break;
                    case 'source_clid':
                        content['wph_clid'] = val;
                        break;
                    default:
                        content['c_' + key] = val;
                        break;
                }
            }

            return content;
        }, {});
    },

    trackSession() {
        const userData = getSessionData(SESSION_PARAMS.user);
        const sessionTimeoutData = getSessionData(SESSION_PARAMS.sessionTimeout);

        if (!userData) {
            setSessionData(SESSION_PARAMS.user, randomId());
            this.newUser = 1;
        } else refreshSessionData(SESSION_PARAMS.user);

        if (!userData || !sessionTimeoutData) {
            setSessionData(SESSION_PARAMS.sessionTimeout, randomId());
        } else refreshSessionData(SESSION_PARAMS.sessionTimeout);
    }
};
